import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import serverClientUtil from '../../../utils/serverClientUtil';
import { handleUserLogout } from '../../../pages/Accounts/createAccount/actions';

import { userCloseSessionIcon } from './svgIcons';

class CloseSessionBtn extends Component {
  handleLogoutFn = () => {
    const { handleLogout, email } = this.props;
    const url = serverClientUtil.getLPFullURL();
    handleLogout(email, this.props.handleUserLogout, url);
  }

  render() {
    return (
      <a
        className="resetDefaultStyleBtn"
        onClick={this.handleLogoutFn}
      >
        { userCloseSessionIcon }
        Cerrar sesión
      </a>);
  }
}

const matchDispatchToProps = dispatch => bindActionCreators({ handleUserLogout }, dispatch);

export default connect(null, matchDispatchToProps)(CloseSessionBtn);
